import { LOGIN_REQUEST, LOGIN_SUCCESS, LOGIN_FAILURE, LOGOUT, CHANGE_PASS, RESPONSE_QUESTIONS } from './../constants';
import { handleActions } from "redux-actions"

let user = JSON.parse(localStorage.getItem('user'));
// console.log('el log ', user.user)
let userResult = {}
if (user) {
  userResult = {
    loggedIn: true,
    user: () => (user.data.user || user.user),
    token: () => (user.data.accessToken || user.accessToken)
  }
}
const initialState = userResult
/* const initialState = user ? { loggedIn: true, user: user.data.user || user.user,
  token: user.data.accessToken || user.accessToken } : {}; */
export const authentication  = handleActions(
  {
    [ LOGIN_REQUEST ]: (state = initialState, action) =>(  
      // {loggingIn: action.payload.state, user: action.payload.user, token: action.payload.accessToken}
      action.payload
    ),
    [ LOGIN_SUCCESS ]: (state = initialState, action) => action.payload,
    [ LOGIN_FAILURE ]: (state = initialState, action) => [{}],
    [ LOGOUT ]: (state, action) => [],
    [ CHANGE_PASS ]: (state, action) => {
      return {...state, user: {...state.user, changePass: action.payload }}
    },
    [ RESPONSE_QUESTIONS ]: (state, action) => {
      //console.log(action.payload)
      return {...state, user: {...state.user, haveQuestions: action.payload }}
    },
  }, {}
)
/* export function authentication(state = initialState, action) {
  console.log(action)
  switch (action.type) {
    case LOGIN_REQUEST:
      return {
        loggingIn: true,
        user: action.payload.user,
        token: action.payload.accessToken,
      };
    case LOGIN_SUCCESS:
      return {
        loggedIn: true,
        user: action.user,
        token: action.payload.accessToken,
      };
    case LOGIN_FAILURE:
      return {};
    case LOGOUT:
      return {};
    default:
      return state
  }
} */